 
export default {
  gCategoriasList(state: any) {
    return state.aCategoriasList
  }
}